import { useEffect, useState } from "react";
import { Modal, Button, Form, InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Clipboard, ClipboardCheck, XCircle } from "react-bootstrap-icons";
// import authApi from "services/authApi";
import { InfoCircleFill } from "react-bootstrap-icons";
import http from "services/httpClient";

function InfoTooltip({ message }: { message: string }) {
  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip id="info-tip">
          <span style={{ whiteSpace: "" }}>{message}</span>
        </Tooltip>
      }
    >
      <span role="button" className="ms-2 text-muted">
        <InfoCircleFill />
      </span>
    </OverlayTrigger>
  );
}

interface ApiKeyModalProps {
  show: boolean;
  onHide: () => void;
  deviceId: number;
}

export default function ApiKeyModal({ show, onHide, deviceId }: ApiKeyModalProps) {
  const [apiKey, setApiKey] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const fetchKey = async () => {
    try {
      const res = await http.get(`/api_key/device/${deviceId}`);
      setApiKey(res.data?.key);
    } catch {
      setApiKey(null);
    }
  };

  const generateKey = async () => {
    setLoading(true);
    try {
      await http.post(`/api_key/device/${deviceId}`, {});
      await fetchKey();
    } catch (err) {
      // console.error("Failed to generate key:", err);
    } finally {
      setLoading(false);
    }
  };

  const deleteKey = async () => {
    if (!window.confirm("Delete API key for this device?")) return;
    setLoading(true);
    try {
      await http.delete(`/api_key/device/${deviceId}`, {});
      setApiKey(null);
    } catch (err) {
      // console.error("Failed to delete key:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    if (!apiKey) return;
    try {
      await navigator.clipboard.writeText(apiKey);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      alert("Failed to copy to clipboard");
    }
  };

  useEffect(() => {
    if (show) fetchKey();
  }, [show]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>API Key Management</Modal.Title>
        <InfoTooltip message="https://dustech.live/api/ external/device/data?api_key=<api_key>"></InfoTooltip>
      </Modal.Header>
      <Modal.Body>
        <p><strong>Device ID:</strong> {deviceId}</p>
        {apiKey ? (
          <InputGroup className="mb-3">
            <Form.Control value={apiKey} readOnly />
            
            <Button variant="outline-secondary" onClick={handleCopy} title="Copy">
              {copied ? <ClipboardCheck /> : <Clipboard />}
            </Button>
            <Button variant="outline-danger" onClick={deleteKey} disabled={loading} title="Delete">
              <XCircle />
            </Button>
          </InputGroup>
        ) : (
          <div className="mb-3">No API key currently exists for this device.</div>
        )}
        <Button variant="primary" onClick={generateKey} disabled={loading}>
          {apiKey ? "Renew Key" : "Generate Key"}
        </Button>
      </Modal.Body>
    </Modal>
  );
}
